export default __webpack_public_path__ + "static/media/Gelbaugenpinguin.13a3d65a.jpg";